export function percentage(value: number, total: number) {
  const percentage = (value / total) * 100

  return percentage.toFixed(2)
}
